import React, { useState, useEffect, useCallback } from 'react';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';

const OnlineTests: React.FC = () => {
    const [exams, setExams] = useState<any[]>([]);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [examDetails, setExamDetails] = useState<Record<number, any>>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isDetailLoading, setIsDetailLoading] = useState(false);
    const [activeTest, setActiveTest] = useState<any>(null);

    const fetchExams = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await serviceApi.get<any>(
                environment.oqExamsResults
            );

            if (response.status === 'SUCCESS') {
                if (response.objectData?.previousResults) {
                    setExams(response.objectData.previousResults);
                }
                if (
                    response.objectData?.activeExam && response.objectData.activeExam.length > 0
                ) {
                    setActiveTest(response.objectData.activeExam[0]);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchExams();
    }, [fetchExams]);
    const formatDuration = (minutes: number) => {
        if (!minutes) return "-";
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hrs && mins) return `${hrs}h ${mins}m`;
        if (hrs) return `${hrs}h`;
        return `${mins}m`;
    };

    const startTest = (test: any) => {
        console.log(test)
        if (test?.testUrl) {
            window.open(test.testUrl, '_blank');
        }
    };

    const handleToggleExpand = async (idx: number, item: any) => {
        if (expandedIndex === idx) {
            setExpandedIndex(null);
            return;
        }

        setExpandedIndex(idx);

        if (!examDetails[idx]) {
            const entityId = item.id || item.oqId;
            setIsDetailLoading(true);

            try {
                const response = await serviceApi.get<any>(
                    environment.oqExamsResults,
                    { entityId }
                );

                if (
                    response.status === 'SUCCESS' &&
                    response.objectData?.questionPaper
                ) {
                    setExamDetails(prev => ({
                        ...prev,
                        [idx]: response.objectData.questionPaper
                    }));
                }
            } catch (err) {
                console.error(err);
            } finally {
                setIsDetailLoading(false);
            }
        }
    };

    return (
        <div className="notification-page">

            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading online tests...</span>
                    </div>
                </div>
            )}

            {/* SAME TITLE STYLE AS NOTIFICATIONS */}
            <h2 className="title-text notification-heading">
                Online Tests
            </h2>
            {activeTest && (
                <div className="event-container">
                    <div
                    // className="event-item"
                    // style={{ display: "flex", alignItems: "stretch", gap: "12px" }}
                    >
                        <div style={{ display: "inline-block", background: "green", padding: "2px 8px", borderRadius: "12px", fontWeight: 600, marginBottom: "6px", color: '#f3f3f3' }}>
                            ACTIVE
                        </div>
                        <div style={{ flex: 1 }}>
                            <div className="title-text">
                                {activeTest.title}
                            </div>
                            <div className="subtitle-text">
                                {activeTest.description || activeTest.subject}
                            </div>
                            <div className="event-description">
                                <b>Duration :</b> {formatDuration(activeTest.duration)}
                            </div>
                            <div className="event-date" style={{ display: "flex", justifyContent: "space-between", color: "#dc3545" }}>
                                <span>
                                    <i className="fa-regular fa-clock"></i>{" "}
                                    Ends : {activeTest.endDate} - {activeTest.endTime}
                                </span>
                                <button className="go-button" onClick={() => startTest(activeTest)}>
                                    Start
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* REMOVE EXTRA PADDING WRAPPER (this was causing width mismatch) */}
            <div>

                {exams.map((item, idx) => {
                    const isExpanded = expandedIndex === idx;
                    const detail = examDetails[idx];

                    return (
                        <div
                            key={idx}
                            className="event-container"
                            style={{ marginBottom: 'var(--sz-16)' }}
                        >
                            <div className="event-item" style={{ padding: '12px' }}>

                                {/* TOP ROW */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '4px'
                                }}>
                                    <div style={{ fontSize: "12px", color: "#888", fontWeight: "500" }}>
                                        <i className="fa-regular fa-calendar" style={{ marginRight: "5px" }}></i>
                                        {item.exam_date}
                                    </div>

                                    <span style={{
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        color: item.status === "ATTEMPTED" ? "#4caf50" : "#ff9800",
                                        border: `1px solid ${item.status === "ATTEMPTED" ? "#4caf50" : "#ff9800"}`,
                                        padding: "1px 6px",
                                        borderRadius: "4px",
                                        textTransform: "uppercase"
                                    }}>
                                        {item.status.replace(/_/g, ' ')}
                                    </span>
                                </div>

                                {/* TITLE ROW */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <h4 style={{
                                        fontSize: '15px',
                                        margin: 0,
                                        color: 'var(--colorPrimaryDark)',
                                        fontWeight: '600',
                                        flex: 1
                                    }}>
                                        {item.title}
                                    </h4>

                                    <button
                                        onClick={() => handleToggleExpand(idx, item)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: 0,
                                            marginLeft: '10px'
                                        }}
                                    >
                                        <i className={`fa-solid ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                            style={{ color: '#aaa', fontSize: '16px' }} />
                                    </button>
                                </div>

                                {/* EXPAND SECTION */}
                                {isExpanded && (
                                    <div style={{ marginTop: '12px', borderTop: '1px solid #eee' }}>

                                        {isDetailLoading && !detail ? (
                                            <div style={{ textAlign: 'center', padding: '15px' }}>
                                                <div className="spinner spinner--sm"></div>
                                            </div>
                                        ) : detail ? (
                                            <>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    textAlign: 'center',
                                                    padding: '12px 0'
                                                }}>
                                                    <div>
                                                        <div style={{ fontSize: '11px', color: '#999' }}>Questions</div>
                                                        <div style={{ fontWeight: '600' }}>
                                                            {detail.questions || detail.questionList?.length}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div style={{ fontSize: '11px', color: '#999' }}>Attempted</div>
                                                        <div style={{ fontWeight: '600' }}>{detail.attempted}</div>
                                                    </div>

                                                    <div>
                                                        <div style={{ fontSize: '11px', color: '#999' }}>Correct</div>
                                                        <div style={{ color: '#28a745', fontWeight: '600' }}>
                                                            {detail.correct}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div style={{ fontSize: '11px', color: '#999' }}>Score</div>
                                                        <div style={{ color: '#007bff', fontWeight: '600' }}>
                                                            {detail.score}/{detail.marks}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive">
                                                    <table className="table table-bordered" style={{ width: '100%', margin: 0 }}>
                                                        <thead style={{ backgroundColor: '#f9f9f9' }}>
                                                            <tr>
                                                                <th style={{ textAlign: 'center', fontSize: '11px' }}>Q.No</th>
                                                                <th style={{ textAlign: 'center', fontSize: '11px' }}>Mrks</th>
                                                                <th style={{ textAlign: 'center', fontSize: '11px' }}>Key</th>
                                                                <th style={{ textAlign: 'center', fontSize: '11px' }}>Ans</th>
                                                                <th style={{ textAlign: 'center', fontSize: '11px' }}>Sts</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {detail.questionList?.map((q: any, qIdx: number) => (
                                                                <tr key={qIdx}>
                                                                    <td style={{ textAlign: 'center' }}>{q.qNo + 1}</td>
                                                                    <td style={{ textAlign: 'center' }}>{q.marks}</td>
                                                                    <td style={{ textAlign: 'center' }}>{q.ans}</td>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        color: q.status === 'correct'
                                                                            ? '#28a745'
                                                                            : q.status === 'wrong'
                                                                                ? '#dc3545'
                                                                                : '#6c757d'
                                                                    }}>
                                                                        {q.ansSelect || 'N/A'}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {q.ansSelect ? (
                                                                            <i className={`fa ${q.correct ? 'fa-check' : 'fa-times'}`}
                                                                                style={{ color: q.correct ? '#28a745' : '#dc3545' }} />
                                                                        ) : (
                                                                            <i className="fa fa-minus" style={{ color: '#adb5bd' }} />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        ) : null}
                                    </div>
                                )}

                            </div>
                        </div>
                    );
                })}

            </div>
        </div>
    );
};

export default OnlineTests;